import { TrainingsTrainingRequestStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type StatusStyle = 'positive' | 'critical' | 'neutral' | 'warning'

export const getStatusConfig = (
  status: TrainingsTrainingRequestStatusEnum
): { label: string; status: StatusStyle } => {
  switch (status) {
    case 'draft':
      return {
        label: i18n.t('trainings.training_requests.my_requests.datatable.status_tag.draft'),
        status: 'neutral',
      }
    case 'review':
      return {
        label: i18n.t('trainings.training_requests.my_requests.datatable.status_tag.pending'),
        status: 'warning',
      }
    case 'approved':
      return {
        label: i18n.t('trainings.training_requests.my_requests.datatable.status_tag.approved'),
        status: 'positive',
      }
    case 'rejected':
      return {
        label: i18n.t('trainings.training_requests.my_requests.datatable.status_tag.rejected'),
        status: 'critical',
      }
    default:
      return {
        label: status,
        status: 'neutral',
      }
  }
}
